<template>
  <div>
    <order-filters
      :orderNumber.sync="payload.orderNumber"
      :surgeryId.sync="payload.surgeryId"
      :orderStatus.sync="payload.orderStatus"
      @apply="getOrders(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Orders</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="orders"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
          >
            <template slot="item" slot-scope="props">
              <tr @click="detail(props.item.id)">
                <td>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    :value="isSelected"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.number }}
                </td>
                <td class="text-left">{{ props.item.quantity }}</td>
                <td class="text-left">
                  {{ props.item.price.currency }} {{ props.item.price.total }}
                </td>
                <td class="text-left">
                  {{ props.item.user.firstName }} {{ props.item.user.lastName }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers.js";
import OrderFilters from "./OrderFilters.vue";
export default {
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          orderNumber: " ",
          surgeryId: null,
          orderStatus: null,
          supplierId: null
        };
      }
    },
    module: {
      type: String,
      default: "orders/LOAD_ORDERS"
    },
    actions: {
      type: Boolean,
      default: true
    }
  },
  components: {
    OrderFilters
  },
  mixins: [Helpers],
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Ordered At",
          align: "left",
          sortable: false,
          value: "createdAt"
        },
        {
          text: "Order Number",
          align: "left",
          sortable: false,
          value: "number"
        },
        {
          text: "Quantity",
          align: "left",
          value: "quantity"
        },
        {
          text: "Total Price",
          align: "left",
          value: "price.total"
        },
        { text: "User", value: "name" }
      ]
    };
  },
  computed: {
    orders() {
      return this.$store.state.orders.orders;
    },
    totalItems() {
      return this.$store.state.orders.totalOrders;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  created() {
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
    setTimeout(() => {
      this.getOrders(this.payload);
    }, 1000);
  },
  methods: {
    getOrders(payload) {
      this.$store
        .dispatch(this.module, payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payload = this.payload;
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getOrders(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getOrders(payload);
      }
    }
  }
};
</script>
